"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1612],{

/***/ 61612:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _1_landing_Landing; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./public/assets/images/home/phone.webp
/* harmony default export */ var phone = ({"src":"/_next/static/media/phone.634a6f94.webp","height":779,"width":447,"blurDataURL":"data:image/webp;base64,UklGRoAAAABXRUJQVlA4WAoAAAAQAAAABAAABwAAQUxQSCkAAAAAkP///4aQ////iZD///+IkP///4OQ////g5D///+DkP///4Nu2NnYYwBWUDggMAAAALABAJ0BKgUACAACQDglnAADCHe8qIAA/vm7jL/uv2JEoDdMcHYfmsgznYDoICAAAA==","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./utils/Constants.ts
var Constants = __webpack_require__(40953);
// EXTERNAL MODULE: ./utils/ImageExport.ts + 6 modules
var ImageExport = __webpack_require__(80645);
// EXTERNAL MODULE: ./node_modules/@mui/material/Rating/Rating.js + 4 modules
var Rating = __webpack_require__(18339);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(5616);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Star.js
var Star = __webpack_require__(14957);
;// CONCATENATED MODULE: ./components/AppStarRating.tsx





function AppStarRating(param) {
    let { Rate  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center",
            textAlign: "center",
            zIndex: 10,
            justifyContent: {
                xs: "center",
                md: "left"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating/* default */.Z, {
            name: "read-only",
            value: Rate,
            precision: 0.1,
            readOnly: true,
            emptyIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Star/* default */.Z, {
                style: {
                    color: "white"
                },
                fontSize: "inherit"
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/home/1-landing/Landing.tsx





 // Import Head for preloading resources




function Landing(param) {
    let { imgSrc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    href: ImageExport/* PLAYSTORE_BLACK.src */.ZE.src,
                    as: "image"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: {
                        xs: "block",
                        md: "flex"
                    },
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: {
                        xs: "90vh",
                        md: "95vh",
                        lg: "60vh"
                    }
                },
                style: {
                    width: "100%",
                    background: "linear-gradient(60.24deg, #08AC17 -21.65%, #4D71D0 93.65%)",
                    position: "relative"
                },
                className: "Landing_WrapperGrid",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            maxWidth: "1440px",
                            display: {
                                xs: "block",
                                md: "flex"
                            },
                            justifyContent: "center",
                            alignItems: "center"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                sx: {
                                    display: {
                                        xs: "block",
                                        md: "flex"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "45%"
                                    },
                                    paddingTop: {
                                        xs: "22px",
                                        md: "0"
                                    },
                                    height: {
                                        xs: "100%",
                                        md: "80%",
                                        xl: "100%"
                                    },
                                    justifyContent: "right",
                                    alignItems: "center"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    sx: {
                                        width: {
                                            xs: "100%",
                                            md: "100%"
                                        },
                                        height: {
                                            xs: "100%",
                                            md: "100%"
                                        },
                                        padding: {
                                            xs: "12% 10% 1% 10%",
                                            md: "1% 8%"
                                        }
                                    },
                                    style: {
                                        color: "white",
                                        lineHeight: "56px",
                                        letterSpacing: "-1%",
                                        zIndex: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            fontWeight: "700",
                                            sx: {
                                                fontSize: {
                                                    xs: "32px",
                                                    md: "56px"
                                                },
                                                margin: {
                                                    xs: "0",
                                                    md: "0"
                                                },
                                                lineHeight: {
                                                    xs: "40px",
                                                    md: "72px"
                                                },
                                                padding: {
                                                    xs: "0",
                                                    md: "0 0 48px 0"
                                                }
                                            },
                                            children: "Sell financial products and earn real money online!"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            sx: {
                                                display: "flex"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                width: "fit-content",
                                                sx: {
                                                    display: {
                                                        xs: "none",
                                                        md: "block"
                                                    },
                                                    marginRight: "32px"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: Constants/* appLink */.ze,
                                                        rel: "preload",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                            src: ImageExport/* PLAYSTORE_BLACK */.ZE,
                                                            alt: "playstore",
                                                            width: 120,
                                                            height: 64,
                                                            priority: true
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                                        sx: {
                                                            display: "flex",
                                                            alignItems: "center"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStarRating, {
                                                                Rate: 4.5
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                variant: "body2",
                                                                style: {
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "default",
                                                                    marginLeft: "4px",
                                                                    marginTop: "5px"
                                                                },
                                                                children: "4.5"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        style: {
                                                            display: "flex",
                                                            alignItems: "center",
                                                            cursor: "default",
                                                            marginTop: "5px"
                                                        },
                                                        children: "50K+ Reviews"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                sx: {
                                    margin: {
                                        xs: "auto",
                                        md: "0"
                                    },
                                    justifyContent: {
                                        xs: "center",
                                        md: "none"
                                    },
                                    paddingTop: {
                                        xs: "0px",
                                        md: "72px"
                                    },
                                    height: {
                                        xs: "100%",
                                        md: "70%"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "45%"
                                    },
                                    display: "flex",
                                    alignItems: "end",
                                    position: "relative",
                                    paddingBottom: {
                                        xs: "0px",
                                        md: "0"
                                    },
                                    overflow: {
                                        xs: "hidden",
                                        md: "visible"
                                    }
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        sx: {
                                            margin: "60px 0",
                                            width: "250px",
                                            height: "500px"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                src: phone,
                                                alt: "phone",
                                                width: 250,
                                                height: 500,
                                                layout: "intrinsic",
                                                priority: true
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                onClick: ()=>{
                                                    window.location.href = Constants/* appLink */.ze;
                                                },
                                                sx: {
                                                    display: [
                                                        "flex",
                                                        "flex",
                                                        "none"
                                                    ],
                                                    cursor: "pointer"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: ImageExport/* PLAYSTORE_BLACK */.ZE,
                                                    alt: "play-store",
                                                    width: 120,
                                                    height: 48,
                                                    style: {
                                                        width: "auto",
                                                        zIndex: "100",
                                                        height: "48px",
                                                        objectFit: "contain",
                                                        alignItems: "center",
                                                        marginLeft: "35px",
                                                        marginTop: "10px"
                                                    }
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            height: {
                                                xs: "150px",
                                                md: "309px"
                                            },
                                            width: {
                                                xs: "200%",
                                                md: "100%"
                                            },
                                            zIndex: 0,
                                            position: "absolute",
                                            left: {
                                                xs: "-200px",
                                                md: "0"
                                            },
                                            bottom: {
                                                xs: "0px",
                                                md: "-80px"
                                            },
                                            right: {
                                                xs: "-200px",
                                                md: "0"
                                            },
                                            margin: "auto",
                                            display: {
                                                xs: "none",
                                                md: "block"
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "100%",
                                            height: "100%",
                                            viewBox: "0 0 797 314",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                opacity: "0.1",
                                                cx: "398.5",
                                                cy: "398.5",
                                                r: "328.5",
                                                stroke: "white",
                                                strokeWidth: "140"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            display: {
                                                xs: "block",
                                                md: "none"
                                            },
                                            position: "absolute",
                                            bottom: "-500px",
                                            left: "50%",
                                            marginLeft: "-330px"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                            width: "660",
                                            height: "712",
                                            viewBox: "0 0 360 612",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                                opacity: "0.1",
                                                cx: "175.5",
                                                cy: "308.5",
                                                r: "273.5",
                                                stroke: "white",
                                                strokeWidth: "70"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "block",
                                md: "none"
                            },
                            justifyContent: "center",
                            width: "100%",
                            textAlign: "center",
                            paddingBottom: "32px",
                            height: ""
                        },
                        children: [
                            imgSrc ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                rel: "preload",
                                href: Constants/* appLink */.ze,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: imgSrc,
                                    alt: "",
                                    width: 120,
                                    height: 48,
                                    style: {
                                        width: "auto",
                                        height: "48px",
                                        objectFit: "contain"
                                    },
                                    loading: "lazy"
                                })
                            }) : null,
                            imgSrc === ImageExport/* PLAYSTORE_BLACK */.ZE ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                width: "100%",
                                textAlign: "center",
                                sx: {
                                    display: "grid",
                                    placeContent: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AppStarRating, {
                                        Rate: 4.5
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "body2",
                                        style: {
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "default",
                                            marginTop: "5px",
                                            color: "white"
                                        },
                                        children: [
                                            "4.5",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                style: {
                                                    opacity: "0.5",
                                                    margin: "0px 8px",
                                                    fontSize: "20px"
                                                },
                                                children: "•"
                                            }),
                                            "50K+ Reviews"
                                        ]
                                    })
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            height: {
                                xs: "100px",
                                md: "289px"
                            },
                            width: {
                                xs: "250px",
                                md: "500px"
                            }
                        },
                        style: {
                            position: "absolute",
                            top: "0",
                            left: "0"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                            width: "100%",
                            height: "434",
                            viewBox: "0 0 389 434",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                                opacity: "0.1",
                                cx: "47.5",
                                cy: "92.5",
                                r: "281.5",
                                stroke: "white",
                                strokeWidth: "120"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
const getServerSideProps = async ()=>{
    const imgSrc = PLAYSTORE_BLACK;
    return {
        props: {
            imgSrc
        }
    };
};
/* harmony default export */ var _1_landing_Landing = (Landing);


/***/ })

}]);